enum GUEST_STATUSES {
  incomplete = 'INCOMPLETE',
  error = 'ERROR',
  new = 'NEW',
  complete = 'COMPLETED',
  verification_pending = 'VERIFICATION_PENDING',
}

enum GROUP_TYPES {
  single = 'S',
  group = 'G',
  family = 'F',
  tourist = 'T',
}

export {GUEST_STATUSES, GROUP_TYPES};
